import { baseApi } from '../../../core/baseApi';
import {
  createListQuery,
  createCreateMutation,
  createUpdateMutation,
  createDeleteMutation,
} from '../../../patterns/crud';
import type { Folder, CreateFolderArgs } from '../types';

export const foldersApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    // List query with STATIC_DATA cache configuration
    getOrganizationFolders: createListQuery<Folder>('/folders', 'Folders')(builder),
    
    // Create mutation
    createFolder: createCreateMutation<Folder, CreateFolderArgs>('/folders', 'Folders')(builder),
    
    // Update mutation
    updateFolder: createUpdateMutation<Folder>('/folders', 'Folders')(builder),
    
    // Delete mutation
    deleteFolder: createDeleteMutation('/folders', 'Folders')(builder),
  }),
});

export const {
  useGetOrganizationFoldersQuery,
  useCreateFolderMutation,
  useUpdateFolderMutation,
  useDeleteFolderMutation,
} = foldersApi;